import { useState } from "react";
import heroImage from "../assets/znz_bch.jpg";

const adventureTypes = [
  { id: "wildlife", label: "Wildlife Safari" },
  { id: "kilimanjaro", label: "Kilimanjaro Trekking" },
  { id: "beach", label: "Beach Holiday" },
  { id: "daytrips", label: "Day Trips" },
  { id: "cultural", label: "Cultural Tour" },
];

export default function Plan() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "",
    phone: "",
    children: "",
    adults: "",
    arrive: "",
    depart: "",
    message: "",
    adventure: [],
    formType: "plan" 
  });

  function handleChange(event) {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setFormData((prev) => {
        const next = new Set(prev.adventure);
        if (checked) {
          next.add(value);
        } else {
          next.delete(value);
        }
        return { ...prev, adventure: Array.from(next) };
      });
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const res = await fetch("/api/send-plan.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const data = await res.json();

    if (data.status === "success") {
      alert("Trip request sent successfully!");
    } else {
      alert("Something went wrong.");
    }
  }

  return (
    <section className="MainBodySection p-0 d-flex flex-column gap-5 mb-5">
      <div
        className="plan-intro"
        style={{
          backgroundImage: `linear-gradient(120deg, rgba(7, 21, 19, 0.7), rgba(7, 21, 19, 0.2)), url(${heroImage})`,
        }}
      >
        <div className="plan-intro-content p-5 text-center">
          <h1 className="mt-5">Plan Your Trip</h1>
          <p className="font-semi-bold mt-3">
            Share your preferred dates, group size, and adventure focus. We will
            reply with a bespoke proposal and next steps for your dream East Africa journey.
          </p>
        </div>
      </div>

      <div className="container">
        <form className="plan-form-card" onSubmit={handleSubmit}>
          <div className="plan-grid">
            <label className="form-group">
              Name
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder=""
              />
            </label>
            <label className="form-group">
              Email
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder=""
              />
            </label>
            <label className="form-group">
              Country From
              <input
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder=""
              />
            </label>
            <label className="form-group">
              Phone Number
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder=""
              />
            </label>
            <label className="form-group">
              Number of Child
              <input
                name="children"
                value={formData.children}
                onChange={handleChange}
                type="number"
                min="0"
                placeholder=""
              />
            </label>
            <label className="form-group">
              Number of Adult
              <input
                name="adults"
                value={formData.adults}
                onChange={handleChange}
                type="number"
                min="1"
                placeholder=""
              />
            </label>
            <label className="form-group">
              Arrive Date
              <input
                name="arrive"
                value={formData.arrive}
                onChange={handleChange}
                type="date"
              />
            </label>
            <label className="form-group">
              Departure Date
              <input
                name="depart"
                value={formData.depart}
                onChange={handleChange}
                type="date"
              />
            </label>
          </div>

          <div className="adventure-block mt-5">
            <p className="font-semi-bold">Type of your Adventure</p>
            <div className="d-flex align-items-center flex-wrap gap-2">
              {adventureTypes.map((option) => {
                const isChecked = formData.adventure.includes(option.label);
                return (
                  <label
                    key={option.id}
                    className={`adventure-chip ${isChecked ? "is-active" : ""}`}
                  >
                    <input
                      type="checkbox"
                      name="adventure"
                      value={option.label}
                      checked={isChecked}
                      onChange={handleChange}
                    />
                    <span className="w-100 flex-shrink-0">{option.label}</span>
                  </label>
                );
              })}
            </div>
          </div>

          <label className="form-group mt-3">
            Message
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Tell us about your travel dreams, flexibility, or special requests."
            />
          </label>

          <div className="plan-form-actions">
            <button type="submit" className="btn btn-primary plan-submit">
              PLAN YOUR TRIP
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
